import { render } from "./CheckoutButtons.vue?vue&type=template&id=6c4a1a02"
import script from "./CheckoutButtons.vue?vue&type=script&lang=js"
export * from "./CheckoutButtons.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__